export default "__VITE_ASSET__Bk6Sn6SO__"